import { CgSpinner } from "react-icons/cg";

import "./Spinner.scss";

export function Spinner() {
  return <CgSpinner className="SCSpinner" />;
}
